module.exports = __webpack_public_path__ + "static/media/spinebuzz-4.007780df.jpg";